class Header {
  constructor() {
    this._init();
  }

  _init() {
    const burger = document.querySelector('.header-primary__burger-button');
    const menu = document.querySelector('.header-primary__menu-social');
    burger?.addEventListener('click', function () {
      if (burger.classList.contains('header-primary__burger-button--active')) {
        burger.classList.remove('header-primary__burger-button--active');
        menu?.classList.remove('header-primary__menu-social--active');
        menu?.classList.add('header-primary__menu-social--inactive');
      } else {
        burger.classList.add('header-primary__burger-button--active');
        menu?.classList.add('header-primary__menu-social--active');
        menu?.classList.remove('header-primary__menu-social--inactive');
      }
    });
  }
}

export const header = new Header();
